import { useMutation } from '@tanstack/react-query';
import { PersonasAPI } from '@newo/api/gateway';
import axios from '@/utils/api/axiosInstance';

export const personasAPI = new PersonasAPI(axios);

// DELETE Persona
export const useDeletePersonaMutation = () =>
    useMutation({
        mutationFn: async ({ personaId }: { personaId: string }) =>
            personasAPI.deletePersona(personaId)
    });
